module.exports = __webpack_public_path__ + "img/offer_blob_1.46c7c56f.png";